import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import * as moment from 'moment';
import {CONFIG_ENV} from '@/config';
import nomenclatoare from '@/store/nomenclatoare';
import iDocumentIntrare from '@/types/iDocumentIntrare';
import iNomCateg from '@/types/iNomCateg';
import iNomTipDoc from '@/types/iNomTipDoc';
import iNomRegistru from '@/types/iNomCateg';
import {dateToStringDDMonYYYY} from '@/modules/utils';
import {ServicesDocument} from '@/modules/ServicesDocument';
type OrNull<T> = { [K in keyof T]: T[K] | null }
type IDocumentIntrare = OrNull<iDocumentIntrare>;

@Component({components: {}})
export default class SecondStepDocumentIntrare extends Vue {
  @Prop({ default: '0' }) readonly appid!: string;
  public docApp: IDocumentIntrare;
  public loadingPdfForDownload:boolean =false;
  public myLocale:any;
  public $refs: any;
  private storeNomenclatoare = getModule(nomenclatoare);
  // private userStore=getModule(User);

  constructor() {
    super();
    this.myLocale=CONFIG_ENV.myLocale;
    this.docApp = {
      id_registru: null,
      id_categ: null,
      id_tip_doc: null,
      id_doc: null,
      data_doc: null,
      categorie_solicitant: null,
      nume_denumire: null,
      cui: null,
      titlu:null,
      descriere:null,
      nr_inreg: null,
      data_inreg: null,
      nr_file: 0,
      este_confidential: false,
      ref_nr_doc: null,
      ref_data_doc: null,
      ref_id_registru: null,
      track_creation_date: null
    }
  }


  public getDocumentIntrare() {
    const vueInst=this;
    ServicesDocument.getDocumentIntrare(Number(vueInst.appid)).then((presponse)=>{
      if(presponse.status==='success'){
        vueInst.docApp=JSON.parse(JSON.stringify(presponse.document));
      }
    });
  }

  public get optionsRegistre(): iNomRegistru[] {
    return JSON.parse(JSON.stringify(this.storeNomenclatoare.NomRegistre));
  }

  public get optionsCategorii(): iNomCateg[] {
    return JSON.parse(JSON.stringify(this.storeNomenclatoare.NomCategorii));
  }

  public get optionsTipDoc(): iNomTipDoc[] {
    return JSON.parse(JSON.stringify(this.storeNomenclatoare.NomTipDoc));
  }

  public displayDataDoc() :string{
    const vueInst=this;
    // @ts-ignore
    var day =moment(vueInst.docApp.track_creation_date.substr(0,10), "YYYY-MM-DD");
    return dateToStringDDMonYYYY(day);
  }

  public preparePdfForDownload(){
    const vueInst = this;
    vueInst.loadingPdfForDownload=true;
    ServicesDocument.getPdfCoverDocument(Number(vueInst.appid)).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'file.pdf'); //or any other extension
      document.body.appendChild(link);
      vueInst.loadingPdfForDownload=false;
      link.click();
      link.remove();
    });
  }

  public get getLinkToQrCode():string{
    return CONFIG_ENV.URL_DOCUMENT.qr_code+'/'+this.appid;
  }

  public finalizeDocument(){
    this.$router.push({name: 'Dashboard'});
  }

  public getDenTipDocument(pIdTipDoc: number): string{
    const vueInst=this;
    let result='';
    const TipDoc = vueInst.storeNomenclatoare.NomTipDoc.find( tipdoc =>{
      return tipdoc.id_tip_doc == pIdTipDoc;
    });
    if(TipDoc){
      result=TipDoc.den_lang_1;
    }
    return result;
  }

  public mounted() {
    const vueInst = this;
    vueInst.getDocumentIntrare();
  }
}
